<template>
  <div class="bg-dark z-[200] relative h-full">
    <div class="max-w-[540px] h-full mx-auto flex flex-col justify-between">
      <div class="px-6 py-8">
        <div class="flex items-center gap-2 mb-6">
          <SvgIcon name="heart_smart_match" :width="24" :height="24" />
          <h2 class="text-headline5 font-semibold gradient-text">{{ t('header') }}</h2>
        </div>
        <div class="flex flex-col gap-4">
          <p class="text-caption text-dark-500">
            {{ t('letAi') }}
          </p>
          <ul class="flex flex-col gap-4">
            <li class="flex flex-col gap-1">
              <div class="flex gap-1 items-center">
                <img
                  src="./assets/images/magnifier.png"
                  width="48"
                  height="48"
                  alt=""
                  class="w-6 h-6"
                />
                <h3 class="text-button1 font-semibold text-dark-500">{{ t('aiFinds') }}</h3>
              </div>
              <p class="text-caption text-dark-500">
                {{ t('endlessSwiping') }}
              </p>
            </li>
            <li class="flex flex-col gap-1">
              <div class="flex gap-1 items-center">
                <img
                  src="./assets/images/love_letter.png"
                  width="48"
                  height="48"
                  alt=""
                  class="w-6 h-6"
                />
                <h3 class="text-button1 font-semibold text-dark-500">{{ t('breakIce') }}</h3>
              </div>
              <p class="text-caption text-dark-500">
                {{ t('firstMove') }}
              </p>
            </li>
          </ul>
          <p class="text-caption text-dark-200">{{ t('disable') }}</p>
        </div>
      </div>

      <div class="gradient-wrapper">
        <div
          class="relative z-10 flex justify-center items-center bg-dark flex-col rounded-t-2xl pt-6 px-6"
        >
          <p class="text-caption text-dark-500 mb-6 text-center" v-html="t('realConnections')"></p>

          <SmartAiButton @click="emit('next')">{{ t('tryIt') }}</SmartAiButton>

          <button class="text-button2 font-semibold text-white p-5 mt-2" @click="emit('close')">
            {{ t('dontWant') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import SmartAiButton from '@/components/inputs/button/SmartAiButton.vue';
import SvgIcon from '@/components/inputs/icon/svg-icon/SvgIcon.vue';
import { useI18n } from '@/services/i18n';

import { messages } from './i18n';

const emit = defineEmits(['close', 'next']);

const { t } = useI18n({ messages });
</script>

<style scoped lang="scss" src="../style.scss"></style>
